<div class="card mb-3">
  <div class="card-header">
    <label>
      {{ "ENTRY_SUMMARY.INVOICE" | translate }}{{ indexSuffix }}:
      <span class="text-error" *ngIf="fieldsConfig.invoiceNumber.hasError">
        {{ fieldsConfig.invoiceNumber.firstError | translate }}
      </span>
      <span *ngIf="!fieldsConfig.invoiceNumber.hasError">
        {{ invoice.invoiceNumber }}
      </span>
    </label>
    <div class="header-action">
      <dropdown-action
        *ngIf="isCanView || isCanEdit"
        [iconColor]="iconColor"
        [menuMode]="menuMode"
        [id]="'dropdownMenuIsfActions-' + invoice.id"
        className="ml-2 d-inline"
      >
        <button *ngIf="isCanView || isCanEdit" dropdown-item class="dropdown-item" (click)="onEdit()">
          {{ (isCanEdit ? "BUTTON.EDIT" : "BUTTON.VIEW") | translate }}
        </button>
        <button *ngIf="isCanEdit" dropdown-item class="dropdown-item" (click)="onAddNewItem()">
          {{ "BUTTON.ADD_PRODUCT_HTS_CODE" | translate }}
        </button>
        <button *ngIf="isShowFinalizeButton" dropdown-item class="dropdown-item" [disabled]="isFinalizeDisabled" (click)="onFinalize()">
          {{ "HTS_ASSISTANT.FINALIZE" | translate }}
        </button>
        <button *ngIf="isCanEdit" dropdown-item class="dropdown-item" (click)="onDelete()">
          {{ "BUTTON.DELETE" | translate }}
        </button>
      </dropdown-action>
    </div>
  </div>
  <div class="card-body pb-0">
    <div class="padding-15">
      <div *ngIf="fieldsConfig.currency.shown" class="row">
        <div class="col-6 label mb-3">{{ "LABELS.CURRENCY" | translate }}</div>
        <div class="col-6 value" [ngClass]="{ error: fieldsConfig.currency.hasError }">
          {{ fieldsConfig.currency.hasError ? (fieldsConfig.currency.firstError | translate) : fieldsConfig.currency.value }}
        </div>
      </div>

      <div *ngIf="fieldsConfig.currencyRate.shown" class="row">
        <div class="col-6 label mb-3">{{ "LABELS.CONVERSION_RATE_TODAY" | translate }}</div>
        <div class="col-6 value" [ngClass]="{ error: fieldsConfig.currencyRate.hasError }">
          {{
            fieldsConfig.currencyRate.hasError
              ? (fieldsConfig.currencyRate.firstError | translate : fieldsConfig.currencyRate.params)
              : fieldsConfig.currencyRate.value
          }}
        </div>
      </div>

      <div *ngIf="fieldsConfig.incoTermsCode.shown" class="row">
        <div class="col-6 label mb-3">{{ "LABELS.INCOTERMS" | translate }}</div>
        <div class="col-6 value" [ngClass]="{ error: fieldsConfig.incoTermsCode.hasError }">
          {{ fieldsConfig.incoTermsCode.hasError ? (fieldsConfig.incoTermsCode.firstError | translate) : incotermName }}
        </div>
      </div>

      <div class="row">
        <div class="col-6 label mb-3">{{ "MANUFACTURER" | translate }}</div>
        <div class="col-6 value mb-3">
          <div *ngIf="manufacturerFieldsConfig?.name?.hasError" class="text-error">
            {{ manufacturerFieldsConfig.name.firstError | translate }}
          </div>

          <div *ngIf="!manufacturerFieldsConfig?.name?.hasError">
            {{ invoice?.manufacturer?.name }}
          </div>

          <address-details [address]="invoice?.manufacturer?.address"></address-details>
          <ng-template [ngIf]="manufacturerFieldsConfig?.address?.hasError">
            <div *ngFor="let error of manufacturerFieldsConfig.address.messages" class="text-error">
              {{ "BACK_ERROR." + error | translate }}
            </div>
          </ng-template>
        </div>
      </div>
    </div>
    <div class="items-header d-flex justify-content-between py-2 px-3">
      <div class="w-50">
        {{ "ENTRY_SUMMARY.LINE_ITEMS" | translate }}
      </div>
      <div class="w-50 d-flex justify-content-between pl-3">
        <span>
          {{ invoice.lines.length }}
        </span>
        <div class="d-flex align-items-center">
          <ng-container *ngIf="isCanBulkDelete && invoice.lines.length">
            <dropdown-action
              *ngIf="!isMultiSelectMode"
              [iconColor]="iconColor"
              [menuMode]="menuMode"
              className=""
              [id]="'es-invoice-summary-bulk-menu-' + invoice.id"
            >
              <button type="button" dropdown-item class="dropdown-item" (click)="enterMultiSelect()">
                {{ "MULTIPLE_CHOICE" | translate }}
              </button>
              <button type="button" dropdown-item class="dropdown-item" (click)="openRemoveAllModal()">
                {{ "REMOVE_ALL_LINE_ITEMS" | translate }}
              </button>
            </dropdown-action>

            <ng-container *ngIf="isMultiSelectMode">
              <span
                class="items-header-bulk-exit"
                [attr.aria-label]="'BUTTON.CANCEL' | translate"
                role="button"
                tabindex="0"
                (click)="exitMultiSelect()"
                (keydown.enter)="exitMultiSelect()"
              >
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none" aria-hidden="true">
                  <path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" />
                </svg>
              </span>
              <i
                class="fa fa-trash-o items-header-bulk-trash"
                [ngClass]="{ 'is-disabled': !selectedIds.size }"
                [attr.aria-label]="'BULK_DELETE_LINE_ITEMS_TITLE' | translate"
                role="button"
                [attr.tabindex]="selectedIds.size ? 0 : null"
                (click)="openBulkDeleteModal()"
                (keydown.enter)="openBulkDeleteModal()"
              ></i>
              <span
                class="chk"
                [ngClass]="{
                  'is-checked': masterState === 'checked',
                  'is-indeterminate': masterState === 'indeterminate'
                }"
                role="checkbox"
                tabindex="0"
                [attr.aria-checked]="masterState === 'indeterminate' ? 'mixed' : masterState === 'checked'"
                [attr.aria-label]="'LABELS.SELECT_ALL_ROWS' | translate"
                (click)="onMasterClick()"
                (keydown.enter)="onMasterClick()"
                (keydown.space)="$event.preventDefault(); onMasterClick()"
              >
                <svg class="chk-icon tick" width="12" height="12" viewBox="0 0 24 24" fill="none" *ngIf="masterState === 'checked'">
                  <path d="M5 12.5l4.2 4.2L19 7" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" />
                </svg>
                <svg class="chk-icon minus" width="12" height="12" viewBox="0 0 24 24" fill="none" *ngIf="masterState === 'indeterminate'">
                  <path d="M6 12h12" stroke="currentColor" stroke-width="2.6" stroke-linecap="round" />
                </svg>
              </span>
              <dropdown-action [isCustomButton]="true" className="" [id]="'es-invoice-summary-bulk-select-menu-' + invoice.id">
                <i custom-dropdown-button class="fa fa-caret-down items-header-bulk-caret" aria-hidden="true"></i>
                <button type="button" dropdown-item class="dropdown-item" (click)="selectAll()">
                  {{ "BULK_SELECT_ALL" | translate }}
                </button>
                <button type="button" dropdown-item class="dropdown-item" (click)="selectNone()">
                  {{ "BULK_SELECT_NONE" | translate }}
                </button>
              </dropdown-action>
            </ng-container>
          </ng-container>
          <!-- Collapsing the list mid-selection would hide the row checkboxes and persist the collapse pref. -->
          <div class="arrow" [ngClass]="{ 'is-disabled': isMultiSelectMode }">
            <icon-toggle-open-close [open]="open" (click)="toggleOpen()"></icon-toggle-open-close>
          </div>
        </div>
      </div>
    </div>
    <div class="list-item" [ngClass]="{ open: open }">
      <ng-container *ngFor="let line of invoice.lines; let index = index">
        <es-invoice-summary-details-line-item
          [transportationMode]="transportationMode"
          [index]="index + 1"
          [item]="line"
          [currencyCode]="invoice.currency"
          [currencyRate]="currencyRate"
          [isCanEdit]="isCanEdit"
          [isCanView]="isCanView"
          [isSelectMode]="isCanBulkDelete && isMultiSelectMode"
          [isSelected]="selectedIds.has(line.id)"
          (edit)="onEditItem(line.id)"
          (delete)="onDeleteItem(line.id)"
          (duplicate)="onDuplicateItem(line)"
          (selectToggle)="toggleRow(line.id)"
        ></es-invoice-summary-details-line-item>
      </ng-container>
    </div>
    <es-invoice-summary-details-total
      [items]="invoice.lines"
      [currency]="invoice.currency"
      [currencyRate]="currencyRate"
      [hideBorderBottom]="true"
    ></es-invoice-summary-details-total>
  </div>
</div>

<es-line-items-bulk-delete-modal
  *ngIf="isCanBulkDelete"
  [isOpen]="isBulkDeleteModalOpen"
  [isLoading]="isBulkDeleting"
  (confirmed)="onBulkDeleteConfirmed()"
  (cancelled)="onBulkDeleteCancelled()"
></es-line-items-bulk-delete-modal>
